import React from "react";
import PropTypes from "prop-types";
import {
  PopContainer,
  PopupHeading,
  PopupContentLine1,
  PopupContentContainer,
  PrimaryButton,
  DisplayFlexCenter,
  Underlinelink,
  PopContainerWrap,
  PopupWrap,
  PopupContentLine1Align,
  IconWrap
} from "./styles";
import { Cross } from "../../../../../../../NPA/Pages/Step1Setup/Components/ExpandClose";

class Popup extends React.Component {
  componentDidMount() {
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = '';
  }

  getContentLine(type) {
    if (type === 'reset') {
      return (
        <DisplayFlexCenter>
          <PopupContentLine1>
          <div dangerouslySetInnerHTML={{__html: this.props.content.line1}}></div></PopupContentLine1>
        </DisplayFlexCenter>
      );
    }
    return (
      <DisplayFlexCenter>
        <PopupContentLine1Align width="88%" paddingBottom="0px">
        <div dangerouslySetInnerHTML={{__html: this.props.content.line1}}></div>
        </PopupContentLine1Align>
      </DisplayFlexCenter>
    );
  }

  resetButton() {
    if (this.props.advisorType === 'Primary' || this.props.advisorType === 'legacy') {
      return <PrimaryButton onClick={this.props.handleReset}>continue</PrimaryButton>
    }
    return <PrimaryButton onClick={this.props.handleResetSecondary}>{this.props.content.continue}</PrimaryButton>
  }

  getButton(type) {
    switch (type) {
      case 'autofill':
        return <PrimaryButton onClick={this.props.handleContinue}>continue</PrimaryButton>
      case 'reset':
        return this.resetButton();
      case 'exit':
        return (
          <PrimaryButton onClick={this.props.handleExitClick}>{this.props.content.continue}</PrimaryButton>
        );
      default:
        return <PrimaryButton onClick={this.props.handleRemove}>{this.props.content.continue}</PrimaryButton>
    }
  }

  render() {
    return (
      <PopContainerWrap>
        <PopupWrap mwidth={this.props.mwidth} width={this.props.width}>
          <PopContainer>
            <IconWrap onClick={this.props.closeModal}>
              <Cross />
            </IconWrap>
            <PopupHeading><div dangerouslySetInnerHTML={{__html: this.props.content.heading}}></div></PopupHeading>
            <PopupContentContainer>
              {this.getContentLine(this.props.content.type)}
              <div className="mb2"><div dangerouslySetInnerHTML={{__html: this.props.content.line2}}></div></div>
            </PopupContentContainer>
            <DisplayFlexCenter>{this.getButton(this.props.content.type)}</DisplayFlexCenter>
            <Underlinelink onClick={this.props.closeModal}><div dangerouslySetInnerHTML={{__html: this.props.content.cancel}}></div></Underlinelink>
          </PopContainer>
        </PopupWrap>
      </PopContainerWrap>
    );
  }
}

Popup.propTypes = {
  content: PropTypes.object,
  closeModal: PropTypes.func,
  mwdith: PropTypes.string,
  width: PropTypes.string
}

export default Popup;